/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'

type PublicRouteProps = {
  component: React.FunctionComponent
  isAuth: boolean
}

const PublicRoute: React.FunctionComponent<PublicRouteProps> = ({
  component: Component,
  isAuth,
  ...rest
  // @ts-ignore
}) => !isAuth && <Component {...rest} />

export default PublicRoute
